import { Loading } from '@/pages/time-off-calendar/user/employee-calendar.loading';

export default Loading;
